import React, { useState } from "react";
import ProductLabs from "./ProductLabs";
import InvestingLabs from "./InvestingLabs";
import RiskLabs from "./RiskLabs";
import FundResearchLab from "./FundResearchLab";

export default function LearningLabs({ initialGroup = "products", initialLab, onOpenLesson }) {
  const [group, setGroup] = useState(() => ["products", "investing", "risk", "research"].includes(initialGroup) ? initialGroup : "products");
  return <>
    <nav className="finance-lab-families" aria-label="Lab collections">
      <button type="button" aria-pressed={group === "products"} onClick={() => setGroup("products")}>Products <small>商品如何運作</small></button>
      <button type="button" aria-pressed={group === "investing"} onClick={() => setGroup("investing")}>Investing <small>投入與提領</small></button>
      <button type="button" aria-pressed={group === "risk"} onClick={() => setGroup("risk")}>Risk <small>風險的不同面向</small></button>
      <button type="button" aria-pressed={group === "research"} onClick={() => setGroup("research")}>Research <small>基金持股與曝險</small></button>
    </nav>
    {group === "products" ? <ProductLabs initialLab={initialLab} onOpenLesson={onOpenLesson} /> : group === "investing" ? <InvestingLabs initialLab={initialLab} onOpenLesson={onOpenLesson} /> : group === "risk" ? <RiskLabs initialLab={initialLab} onOpenLesson={onOpenLesson} /> : <FundResearchLab onOpenLesson={onOpenLesson} />}
  </>;
}
